module.exports = __webpack_public_path__ + "static/media/WheatStage120.a4fc1c00.PNG";